import React, { useContext, useEffect, useState } from "react";
import IOrder from "../../../models/IOrder";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import * as _ from "lodash-es";
import IOnGetBillOfLadingDTO from "../../../models/DTO/IOnGetBillOfLadingDTO";
import IGetBillOfLadingDTO from "../../../models/DTO/IGetBillOfLadingDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import { BillOfLadingDetail } from "./BillOfLadingDetail/BillOfLadingDetail";
import OwPrintButton from "../OwPrintButton/OwPrintButton";
import "./BillOfLading.scss";
import {SocketContext} from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";

type Props = {};

export const BillOfLading: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const location = useLocation();
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const [orders, setOrders] = useState<IOrder[]>([]);

    useEffect(() => {
        socket.on(EndpointsEnum.ShipmentOnGetBillOfLading, onGetBillOfLading);

        getBillOfLading();

        return () => {
            socket.removeListener(EndpointsEnum.ShipmentOnGetBillOfLading, onGetBillOfLading);
        };
    }, []);

    const getBillOfLading = () => {
        const queryStringValues = queryString.parse(location.search);

        const qsOrders = queryStringValues.orders;

        const billOfLadingOrders: string[] = [];

        if (_.isString(qsOrders)) {
            const orderGuidStrings = qsOrders?.split(",");

            for (const str of orderGuidStrings) {
                billOfLadingOrders.push(str);
            }
        }

        const payload: IGetBillOfLadingDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            orderGuids: billOfLadingOrders,
        };

        socket.emit(EndpointsEnum.ShipmentGetBillOfLading, payload);
    };

    const onGetBillOfLading = (data: IOnGetBillOfLadingDTO) => {
        setOrders(data.orders);

        // set the window title
        document.title = `Orderwerks >> Shipments >> Bill of Lading (${data.orders.length})`;
    };

    return (
        <div className={"BillOfLading"}>
            <div className={"text-end"}>
                <OwPrintButton/>
            </div>

            {orders.map((order) => {
                return (
                    <div key={order.guid}>
                        <BillOfLadingDetail order={order} />
                    </div>
                );
            })}
        </div>
    );
};
